import Spacer from '@ulta/core/components/Spacer/Spacer';

export default Spacer;